import React, { useContext } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    clearErrors,
  } = useForm();

  const imageFile = watch("image");
  const [imagePreview, setImagePreview] = useState(null);

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("name", data?.name);
    //   finalData.append("subname", data?.subname);
      finalData.append("rating", data?.rating);
      finalData.append("message", data?.message);
     finalData.append("image", data?.image[0]);

      const response = await postData(`/admin/masters/ourcustomersays`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response?.data });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      clearErrors("image");
    }
  };

  return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Our Customer Says</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>

            <Row>

              {/* NAME */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter name"
                        className={classNames({ "is-invalid": errors?.name })}
                        {...register("name", {
                          required: "Name is required",
                          maxLength: { value: 200, message: "Max 200 chars allowed" },
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* SUBNAME */}
{/*               
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Subname</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter subname"
                        className={classNames({
                          "is-invalid": errors?.subname,
                        })}
                        {...register("subname", {
                          maxLength: { value: 200, message: "Max 200 chars allowed" },
                        })}
                      />
                    </InputGroup>
                    {errors.subname && (
                      <span className="text-danger">
                        {errors.subname.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}



              {/* RATING */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Rating (1 - 5)</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Enter rating"
                        className={classNames({
                          "is-invalid": errors?.rating,
                        })}
                        {...register("rating", {
                          required: "Rating is required",
                          valueAsNumber: true,
                          min: { value: 1, message: "Minimum rating is 1" },
                          max: { value: 5, message: "Maximum rating is 5" },
                        })}
                      />
                    </InputGroup>
                    {errors.rating && (
                      <span className="text-danger">
                        {errors.rating.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* DESCRIPTION */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter message"
                        className={classNames({
                          "is-invalid": errors?.message,
                        })}
                        {...register("message", {
                          required: "Description is required",
                          maxLength: {
                            value: 200,
                            message: "Max 200 chars allowed",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.message && (
                      <span className="text-danger">
                        {errors.message.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* IMAGE */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Image</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        className={classNames({
                          "is-invalid": errors?.image,
                        })}
                        {...register("image", {
                          required: "Image is required",
                        })}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}

                    {imagePreview && (
                      <img
                        src={imagePreview}
                        className="mt-2"
                        style={{ maxWidth: "100px" }}
                        alt="Preview"
                      />
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* BUTTONS */}
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>

            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;